import React, {Component} from 'react';
import moment from 'moment';
import {Row, Col, Table, Button, Modal, Icon, Form, Select, Input, DatePicker, InputNumber} from 'antd';
import {api, app, config} from "../../app";
import utils from "../../utils";

const FormItem = Form.Item, Option = Select.Option, TextArea = Input.TextArea;

function formItemLayout(span) {
    return {
        labelCol: {span: 5},
        wrapperCol: {span: span || 18, offset: 1}
    }
}

class Trainconfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {},
            modal_train: {},
            data_loding: true,
            class_loading: true,
            detail_loading: false,
            edit_loading: false,
            data_total: 0,
            visible: 0,
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.handelClassList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 获取详情
     * @param train_id
     */
    getDetail = (train_id) => {
        this.setState({detail_loading: true});
        const _this = this, params = {
            train_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            token: app.getData('token'),
        };
        app.post(api.TrainDetails2, params).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.setState({modal_train: data});
                } else {
                    app.alert(msg, "error");
                }
                _this.setState({detail_loading: false});
            }
        });
    }

    /**
     * 页面数据加载
     */
    handleLoading = () => {
        this.setState({data_loding: true});
        const _this = this, data = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            token: app.getData('token'),
            page: this.state.page
        }, pagination = this.state.pagination;
        app.post(api.TrainList2, data).then(({flag, total, data, msg}) => {
            if (_this._isMounted) {
                _this.setState({data_loding: false});
                if (flag === 1) {
                    pagination.total = parseInt(total || 0);
                    _this.setState({trainList: utils.addArrayKey(data), pagination});
                } else {
                    app.alert(msg, "error");
                }
            }
        });
    }

    componentDidMount() {
        this.handleLoading();
    }

    /**
     * 表格数据变更
     * @param pagination
     */
    handleTableChange = (pagination) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
        });
        this.handleLoading();
    }

    /**
     * 取消弹框
     */
    handleModalCancel = () => {
        this.setState({visible: 0});
    }

    /**
     * 打开对话框
     * @param visible
     * @param id
     */
    handleModalOpen = (visible, id) => {
        this.getDetail(id);
        this.setState({visible: visible});
    }

    /**
     * 类型查询
     */
    handelClassList() {
        const _this = this;
        app.post(api.HomeClassList).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                _this.setState({class_loading: false});
                if (flag === 1) {
                    _this.setState({classList: data});
                } else {
                    app.alert(msg, "warn");
                }
            }
        })
    }

    render() {
        const columns = [
                {
                    title: '省份',
                    dataIndex: 'sf',
                    key: 'sf',
                    width: '10%'
                },
                {
                    title: '队伍名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '20%',
                },
                {
                    title: '参与人员数量',
                    dataIndex: 'join_number',
                    key: 'join_number',
                    width: '10%',
                },
                {
                    title: '培训地点',
                    dataIndex: 'train_site',
                    key: 'train_site',
                    width: '35%'
                },
                {
                    title: '状态',
                    dataIndex: 'train_status',
                    key: 'train_status',
                    width: '10%',
                    render: (text, record) => {
                        let str = '';
                        switch (record.train_status) {
                            case '0':
                                str = '未开始';
                                break;
                            case '1':
                                str = '进行中';
                                break;
                            case '2':
                                str = '已完成';
                                break;
                            case '3':
                                str = '已取消';
                                break;
                        }
                        return str;
                    }
                },
                {
                    title: '操作',
                    dataIndex: '',
                    key: 'action',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <Row className="table-action" type="flex" justify="space-around">
                                <Button type="primary" size="small"
                                        onClick={() => this.handleModalOpen('1', record.train_id)}>详情</Button>
                                <Button type="primary" size="small"
                                        onClick={() => this.handleModalOpen('2', record.train_id)}>编辑</Button>
                                <Button type="primary" size="small">确定</Button>
                            </Row>
                        );
                    }
                }
            ],
            loading = this.state.data_loding,
            detail_loading = this.state.detail_loading,
            trainList = this.state.trainList || [],
            data_total = this.state.data_total,
            modal_train = this.state.modal_train,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无数据',
            },
            {getFieldDecorator} = this.props.form,
            classList = this.state.classList,
            edit_loading = this.state.edit_loading,
            visible = this.state.visible;
        modal_train.images = modal_train.images || [];
        let train_status_txt = '';
        switch (modal_train.train_status) {
            case '0':
                train_status_txt = '未开始';
                break;
            case '1':
                train_status_txt = '进行中';
                break;
            case '2':
                train_status_txt = '已完成';
                break;
            case '3':
                train_status_txt = '已取消';
                break;
        }

        return (
            <div className="train-confirm">
                <div className="page-title">培训任务确认<span>Training task confirmation</span></div>
                <Row className="page-content">
                    <Table className="table"
                           size="middle"
                           locale={locale}
                           columns={columns}
                           dataSource={trainList}
                           loading={loading}
                           onChange={this.handleTableChange}
                           pagination={{
                               total: data_total,
                               pageSize: 20,
                               showTotal: (total) => `总数: ${total}`
                           }}/>
                    {visible === '1' ?
                        <Modal
                            visible={visible === '1'}
                            title={<div style={{textAlign: 'center'}}>培训任务详情<span>{detail_loading ? (
                                <Icon
                                    type="loading"/>) : (modal_train.trainame ? `（${modal_train.trainame}）` : '')}</span>
                            </div>}
                            // onOk={this.handleOk}
                            onCancel={this.handleModalCancel}
                            width="80%"
                            className="train_confirm_modal"
                            footer={null}
                        >
                            <div className='modal-content'>
                                <Row className='item'>
                                    <Col span={5}>地区：</Col>
                                    <Col span={18} offset={1}>暂无数据</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>培训后所得技能：</Col>
                                    <Col span={18} offset={1}>{modal_train.train_ppe || ''}</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>培训队伍：</Col>
                                    <Col span={18} offset={1}>无</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>装备：</Col>
                                    <Col span={18} offset={1}>{modal_train.train_equip || '无'}</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>培训地点：</Col>
                                    <Col span={18} offset={1}>{modal_train.train_site || '无'}</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>培训课时：</Col>
                                    <Col span={18} offset={1}>地区</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>技能类型：</Col>
                                    <Col span={18} offset={1}>地区</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>培训人员：</Col>
                                    <Col span={18} offset={1}>{modal_train.train_number || 0}人</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>状态：</Col>
                                    <Col span={18} offset={1}>{train_status_txt || '无'}</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>开始培训时间：</Col>
                                    <Col span={18}
                                         offset={1}>{modal_train.startdate ? moment(modal_train.startdate).format("YYYY年MM月DD日 HH:mm") : '无'}</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>培训详情：</Col>
                                    <Col span={18} offset={1}>{modal_train.train_content || '无'}</Col>
                                </Row>
                                <Row className='item'>
                                    <Col span={5}>上传培训图片：</Col>
                                    <Col span={18} offset={1}>{
                                        modal_train.images.map((img, index) => {
                                            return (
                                                <img key={index + 1} src={config.imgUrl + img} className="img" alt=""/>
                                            );
                                        })
                                    }</Col>
                                </Row>
                            </div>
                        </Modal>
                        : ''
                    }
                    {visible === '2' ?
                        <Modal
                            visible={visible === '2'}
                            title={<div style={{textAlign: 'center'}}>编辑培训任务<span>{detail_loading ? (
                                <Icon
                                    type="loading"/>) : (modal_train.trainame ? `（${modal_train.trainame}）` : '')}</span>
                            </div>}
                            // onOk={this.handleOk}
                            onCancel={this.handleModalCancel}
                            width="80%"
                            className="train_edit_modal"
                            footer={
                                <Row type="flex" justify="center">
                                    <Button type="primary" loading={edit_loading}>修改</Button>
                                    <Button type="primary">确认</Button>
                                    <Button onClick={this.handleModalCancel}>取消</Button>
                                </Row>}
                        >
                            <Form onSubmit={this.handleSubmit}>
                                <FormItem
                                    label="培训技能"
                                    className='item'
                                    {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('class_id', {
                                        rules: [{required: true, message: '请选择培训技能!'}],
                                    })(
                                        <Select placeholder="请选择培训技能" notFoundContent="请刷新页面重试~">
                                            {
                                                classList.map((cla, index) => {
                                                    return (
                                                        <Option key={index + 1} value={cla.id}>{cla.names}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训名称"
                                    className='item'
                                    {...formItemLayout()}
                                >
                                    {getFieldDecorator('trainame', {
                                        rules: [{required: true, message: '请填写培训名称!'}],
                                    })(
                                        <Input placeholder="请填写培训名称"/>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训时间"
                                    className='item'
                                    {...formItemLayout()}
                                >
                                    {getFieldDecorator('date', {
                                        rules: [{required: true, message: '请选择培训时间!'}],
                                    })(
                                        <DatePicker.RangePicker
                                            showTime={{format: 'HH:mm'}}
                                            format="YYYY年MM月DD日 HH:mm"
                                            placeholder={['开始日期', '结束日期']}
                                            style={{width: '100%'}}
                                        />
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训地点"
                                    className='item'
                                    {...formItemLayout()}
                                >
                                    {getFieldDecorator('train_site', {
                                        rules: [{required: true, message: '请填写培训地点!'}],
                                    })(
                                        <Input placeholder="请填写培训地点"/>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训师"
                                    className='item'
                                    {...formItemLayout()}
                                >
                                    {getFieldDecorator('train_teacher', {
                                        rules: [{required: true, message: '请填写培训师!'}],
                                    })(
                                        <Input placeholder="请填写培训师"/>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训级别"
                                    className='item'
                                    {...formItemLayout(8)}
                                >
                                    {getFieldDecorator('goods_name0', {
                                        rules: [{required: true, message: '请选择培训级别!'}],
                                    })(
                                        <Select placeholder="请选择培训级别">
                                            <Option value="jack">省</Option>
                                            <Option value="lucy">市</Option>
                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训人数"
                                    className='item'
                                    {...formItemLayout(5)}
                                >
                                    {getFieldDecorator('train_number', {
                                        rules: [{required: true, message: '请填写培训人数!'}],
                                    })(
                                        <InputNumber style={{width: '100%'}} min={1} placeholder="请填写培训人数"/>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训后获得技能"
                                    className='item'
                                    {...formItemLayout()}
                                >
                                    {getFieldDecorator('train_ppe')(
                                        <Select
                                            mode="tags"
                                            placeholder="请填写培训后可获得技能"
                                            allowClear={true}
                                            tokenSeparators={[',']}
                                            notFoundContent=""
                                        >

                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训需要的装备"
                                    className='item'
                                    {...formItemLayout()}
                                >
                                    {getFieldDecorator('train_equip')(
                                        <Select
                                            mode="tags"
                                            placeholder="请填写培训需要的装备"
                                            allowClear={true}
                                            tokenSeparators={[',']}
                                            notFoundContent=""
                                        >

                                        </Select>
                                    )}
                                </FormItem>
                                <FormItem
                                    label="培训内容"
                                    className='item'
                                    {...formItemLayout()}
                                >
                                    {getFieldDecorator('train_content', {
                                        rules: [{required: true, message: '请填写培训内容!'}],
                                    })(
                                        <TextArea rows={6} placeholder="请填写培训内容"></TextArea>
                                    )}
                                </FormItem>
                            </Form>
                        </Modal>
                        : ''
                    }
                </Row>
            </div>
        );
    }
}

export default Form.create()(Trainconfirm);



// WEBPACK FOOTER //
// ./src/routes/task/Trainconfirm.jsx